import { Input, InputGroup, InputProps } from '@chakra-ui/react';
import { useCallback } from 'react';
import { CloseIcon, SearchIcon } from 'vectors';

interface SearchInputProps extends InputProps {
  query: string;
  setQuery: (query: string) => void;
  onClear?: () => void;
  dataTestId?: string;
  placeholder?: string;
}

const SearchInput = (props: SearchInputProps) => {
  const { query, setQuery, onClear, dataTestId, placeholder = 'Search', ...rest } = props;

  const onChange = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      setQuery(ev.target.value);
    },
    [setQuery],
  );

  return (
    <InputGroup
      startElement={<SearchIcon color="icon.tertiary" boxSize={4} />}
      endElement={
        onClear != null &&
        query.length > 0 && (
          <CloseIcon
            color="gray.500"
            cursor="pointer"
            boxSize={3}
            style={{ cursor: 'pointer' }}
            onClick={onClear}
          />
        )
      }
    >
      <Input
        {...rest}
        placeholder={placeholder}
        data-testid={dataTestId}
        value={query}
        onChange={onChange}
        borderColor="border.light"
        borderWidth="1px"
      />
    </InputGroup>
  );
};

export default SearchInput;
